import { combineReducers } from '@reduxjs/toolkit'

import { flowReducer } from './slice'
import { toFlowApi } from './rtkApi/toFlowApi'

export const rootReducer: any = combineReducers({
  calc: flowReducer,
  [toFlowApi.reducerPath]: toFlowApi.reducer,
})
